<template>
  <div>
    <div v-if="loading" class="container loading-container">
      <el-card class="noticia-card">
        <el-skeleton :rows="10" animated />
      </el-card>
    </div>

    <div v-else class="container">
      <el-button
        class="closeButton"
        type="primary"
        circle
        @click="volver"
      >
        <el-icon><ArrowLeft /></el-icon>
      </el-button>

      <el-card class="noticia-card">
        <el-row :gutter="24" align="middle">
          <el-col :xs="22" :sm="23" :md="22">
            <h1 class="title">{{ noticia.Titulo }}</h1>
          </el-col>

          <el-col :xs="2" :sm="1" :md="2" class="closeIconContainer">
            <router-link :to="backRoute" aria-label="Cerrar noticia">
              <el-icon><CircleClose /></el-icon>
            </router-link>
          </el-col>
        </el-row>

        <el-row v-if="noticia.PathImagen" class="mainImageRow">
          <el-col :span="24" class="imageColumn">
            <el-image
              class="imagen"
              :src="noticia.PathImagen"
              :preview-src-list="[noticia.PathImagen]"
              preview-teleported
              fit="contain"
            >
              <template #error>
                <div class="imageSlot">
                  <el-icon><PictureFilled /></el-icon>
                </div>
              </template>
            </el-image>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <p class="copete">{{ noticia.Copete }}</p>
          </el-col>
        </el-row>

        <el-row class="contentRow">
          <el-col :span="24">
            <MdPreview
              :id="`noticia-${noticia.Id || $route.params.id}`"
              :model-value="cuerpoRenderizado"
              class="noticiaMarkdownPreview"
              preview-theme="default"
              :sanitize="sanitizeNoticiaPreviewHtml"
              :no-mermaid="true"
              :no-katex="true"
              :no-echarts="true"
              :no-highlight="true"
              :no-img-zoom-in="true"
            />
          </el-col>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
import { MdPreview } from 'md-editor-v3'
import 'md-editor-v3/lib/preview.css'
import { resolveNoticiaImageSources, sanitizeNoticiaHtml } from './noticiaMarkdown'

export default {
  name: 'NoticiaItem',
  components: { MdPreview },
  data() {
    return {
      noticia: {},
      loading: false,
      cuerpoRenderizado: '',
      imageObjectUrls: []
    }
  },
  computed: {
    backRoute() {
      const openedFromGestion = this.$route.name === 'Visualizacion Noticia'
        || this.$route.query.from === 'gestionNoticias'

      return openedFromGestion
        ? { name: 'Gestion Noticias', query: { keepFilter: 'true' } }
        : { name: 'Home' }
    }
  },
  methods: {
    async getNoticia() {
      this.loading = true
      try {
        const result = await this.$store.dispatch('noticias/getNoticia', {id: this.$route.params.id})
        this.releaseImageObjectUrls()
        this.noticia = result || {}

        const resolved = await resolveNoticiaImageSources(this.noticia.Cuerpo)
        this.cuerpoRenderizado = resolved.markdown
        this.imageObjectUrls = resolved.objectUrls
      } finally {
        this.loading = false
      }
    },

    sanitizeNoticiaPreviewHtml(html) {
      return sanitizeNoticiaHtml(html, { allowLocalBlob: true })
    },

    releaseImageObjectUrls() {
      this.imageObjectUrls.forEach(url => URL.revokeObjectURL(url))
      this.imageObjectUrls = []
    },

    volver() {
      console.log('back')
      this.$router.push(this.backRoute)
    }
  },
  // created() {
  //   this.getNoticia()
  // },
    mounted() {
    let id = this.$route.params.id
    this.getNoticia(id)
    },
    beforeUnmount() {
      this.releaseImageObjectUrls()
  }
}
</script>


<style scoped>
.container {
  padding: 20px 40px 40px 20px;
  text-align: left;
}

.loading-container {
  min-height: 300px;
}

.noticia-card {
  width: 100%;
}

.title {
  margin: 0;
  font-weight: bold;
  font-size: 42px;
  line-height: 49px;
  color: var(--main-color);
  padding-bottom: 7px;
  width: fit-content;
  border-bottom: 2px solid var(--main-color); 
}

.closeIconContainer {
  padding: 9px 0;
  text-align: right;
}
.closeIconContainer span {
  font-size: 35px;
  cursor: pointer;
}
.closeIconContainer .el-icon {
  font-size: 30px;
}
.copete {
  margin: 20px 0;
}
.contentRow {
  align-items: flex-start;
}
.mainImageRow {
  margin-top: 8px;
}
.imageColumn {
  margin-bottom: 20px;
  text-align: center;
}
.imagen {
  display: block;
  width: 100%;
  max-width: 680px;
  height: 360px;
  margin: 0 auto;
  border-radius: 4px;
  background: var(--el-fill-color-lighter);
}
.imageSlot {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: var(--el-text-color-placeholder);
  font-size: 32px;
}
.noticiaMarkdownPreview {
  min-width: 0;
  overflow-wrap: anywhere;
}
.noticiaMarkdownPreview :deep(.md-editor-preview) {
  padding: 0;
  white-space: normal;
}
.noticiaMarkdownPreview :deep(.md-editor-preview p) {
  white-space: pre-line;
}
.noticiaMarkdownPreview :deep(.md-editor-preview ul),
.noticiaMarkdownPreview :deep(.md-editor-preview ol) {
  padding-left: 2em;
}
.noticiaMarkdownPreview :deep(.md-editor-preview img) {
  display: block;
  width: 420px;
  max-width: 100%;
  height: 260px;
  margin: 16px auto;
  object-fit: contain;
}
.noticiaMarkdownPreview :deep(.md-editor-preview blockquote) {
  border-left: 4px solid var(--ds-color-brand-500) !important;
  background-color: var(--ds-color-brand-50) !important;
  color: var(--ds-color-brand-900) !important;
}

.closeButton {
  position: fixed;
  right: 20px;
  height: 50px;
  width: 50px;
}

@media (max-width: 768px) {
  .container {
    padding: 20px 12px 30px;
  }

  .title {
    font-size: 30px;
    line-height: 36px;
  }

  .imagen {
    height: 260px;
  }

  .noticiaMarkdownPreview :deep(.md-editor-preview img) {
    width: 100%;
    max-width: 360px;
    height: 220px;
  }
}
</style>

